module.exports = __webpack_public_path__ + "prev.9b619b2a5bd58b3a9bdea3b58ac9a7f2.svg";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/img/prev.svg
// module id = 1653
// module chunks = 39